export const impactoFinanceiroOptions = [
  { id: 1, value: 'Indiferente', icon: 'neutro' },
  { id: 2, value: 'Positivo', icon: 'sucesso' },
  { id: 3, value: 'Negativo', icon: 'negativo' },
  { id: 4, value: 'Não Mensurável', icon: 'mensuravel' },
];